export const SUPPORTED_LOCALES = ['pt-BR', 'en-US', 'es'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]
export const DEFAULT_LOCALE: Locale = 'pt-BR'
export const LOCALE_COOKIE = 'locale'

export const LOCALE_LABELS: Record<Locale, string> = {
  'pt-BR': 'Portugues',
  'en-US': 'English',
  'es': 'Espanol',
}

export const LOCALE_SHORT: Record<Locale, string> = {
  'pt-BR': 'PT',
  'en-US': 'EN',
  'es': 'ES',
}

export const LOCALE_FLAGS: Record<Locale, string> = {
  'pt-BR': '\u{1F1E7}\u{1F1F7}',
  'en-US': '\u{1F1FA}\u{1F1F8}',
  'es': '\u{1F1EA}\u{1F1F8}',
}

// Recursively widen string literals to string
type DeepStringify<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends object
      ? DeepStringify<T[K]>
      : T[K]
}

// The translation shape is inferred from the pt-BR file, with widened string types
export type Translations = DeepStringify<typeof import('./pt-BR').default>

// ─── Client subset ──────────────────────────────────────────────────────────
// Só estes namespaces são consumidos por client components (useTranslations).
// Os restantes (about, financing, contact, labels, meta, domain) ficam
// server-only e NÃO são serializados no payload RSC de cada página pública.
export const CLIENT_NAMESPACES = [
  'common',
  'home',
  'catalog',
  'detail',
  'form',
  'newsletter',
  'fabricantes',
] as const

export type ClientNamespace = (typeof CLIENT_NAMESPACES)[number]
export type ClientTranslations = Pick<Translations, ClientNamespace>

export function pickClientTranslations(t: Translations): ClientTranslations {
  const subset = {} as Record<ClientNamespace, unknown>
  for (const ns of CLIENT_NAMESPACES) {
    subset[ns] = t[ns]
  }
  return subset as ClientTranslations
}
